module.exports = __webpack_public_path__ + "bin/4448c056e0f46d823f364f307e973f40.jpg";